//! Grant Access (with GroupShare) - under development
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import * as reactDeviceDetect from "react-device-detect";

const retractableRegistryDB = fire.database().ref("retractableSharingRegistry");

const registeredUsersOnPlatformDB = fire
  .database()
  .ref("registeredUsersOnPlatform");

const userLocksDb = fire.database().ref("userLocks");

const shareHistoryDB = fire.database().ref("MyShareHistory");

const groupManagementDB = fire.database().ref("GroupManagement");
const groupManagementDB2 = fire.database().ref("lockGroupManagement");

const getUserId = async (email) => {
  const url =
    "https://us-central1-egeetouchindustrial.cloudfunctions.net/getUserByEmail";

  let userId = "";

  await fetch(url, {
    method: "POST",
    body: JSON.stringify({ email: email }),
  }).then(async (response) => {
    const responseResult = await response.json();
    userId = responseResult.uid;
  });

  return userId;
};

const getDeviceDetails = () => {
  let browser = "";
  let device = "";
  let version = "";
  if (reactDeviceDetect.isMobile) {
    device = reactDeviceDetect.mobileModel;
    browser = reactDeviceDetect.browserName;
    version = reactDeviceDetect.fullBrowserVersion;
  } else if (reactDeviceDetect.isDesktop) {
    device = reactDeviceDetect.osName;
    browser = reactDeviceDetect.browserName;
    version = reactDeviceDetect.fullBrowserVersion;
  }

  return device + " using " + browser + ", version " + version;
};

const saveActivityLogs = async (
  selectedRecipients,
  selectedLock,
  sharingMode,
  multiApprove,
  OTAMode,
  timedMode
) => {
  let activityLogsDB = fire
    .database()
    .ref("activityLogs")
    .child(auth.currentUser.uid);
  let activityKey = activityLogsDB.push().key;

  let notificationsDB = fire
    .database()
    .ref("individualNotifications")
    .child(auth.currentUser.uid);
  let notificationsKey = notificationsDB.push().key;

  // check through all superadmins in groupAccounts
  await fire
    .database()
    .ref("groupAccounts")
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        snapshot.forEach((superAdmin) => {
          const superadminUID = superAdmin.key;

          // if user is superadmin
          if (superAdmin.key === auth.currentUser.uid) {
            // add into activityLogs if the user had selected multi approval
            if (multiApprove) {
              // add into activityLogs of the user's activity
              fire
                .database()
                .ref("activityLogs")
                .child(auth.currentUser.uid) // get uid from auth person object
                .child(activityKey)
                .set({
                  isRead: false,
                  activity: 1,
                  key: activityKey,
                  Type: 1,
                  description: "Granted access for multi approval",
                  email: auth.currentUser.email,
                  time: Math.floor(new Date()),
                  userUID: auth.currentUser.uid,
                  device: getDeviceDetails(),
                });
            }

            // selectedRecipients.forEach(async Recipient => {
            //   // call cloud function getUserByEmail to get uid of recipient
            //   let RecipientUID = await getUserId(Recipient.userEmail);
            //   let curUserName = auth.currentUser.displayName;

            //   if(sharingMode){
            //     let message = '';

            //     // check if one time access
            //     if (OTAMode) {
            //       //  check if timed
            //       timedMode
            //       ? message = ' has given you a Timed One-Time online lock access to '
            //       : message = ' has given you One-Time online lock access to ';

            //     } else {
            //       timedMode
            //       ? message = ' has given you a Timed online lock access to '
            //       : message = ' has given you online lock access to ';
            //     };

            //     fire
            //       .database()
            //       .ref("individualNotifications")
            //       .child(RecipientUID)
            //       .child(notificationsKey)
            //       .set({
            //           isRead: false,
            //           snapKey: notificationsKey,
            //           notificationType: 1,
            //           description: curUserName + message + selectedLock,
            //           senderEmail: auth.currentUser.email,
            //           timeStamp: Math.floor(new Date()),
            //           senderUID: auth.currentUser.uid,
            //           device: getDeviceDetails()
            //       });
            //   } else {
            //     let message = '';

            //     // check if one time access
            //     if (OTAMode) {
            //       //  check if timed
            //       timedMode
            //       ? message = ' has given you a Timed One-Time offline lock access to '
            //       : message = ' has given you One-Time offline lock access to ';

            //     } else {
            //       timedMode
            //       ? message = ' has given you a Timed offline lock access to '
            //       : message = ' has given you offline lock access to ';
            //     };

            //     fire
            //       .database()
            //       .ref("individualNotifications")
            //       .child(RecipientUID)
            //       .child(notificationsKey)
            //       .set({
            //           isRead: false,
            //           snapKey: notificationsKey,
            //           notificationType: 1,
            //           description: curUserName + message + selectedLock,
            //           senderEmail: auth.currentUser.email,
            //           timeStamp: Math.floor(new Date()),
            //           senderUID: auth.currentUser.uid,
            //           device: getDeviceDetails()
            //       });
            //   }
            // });
          } else {
            // check if user is under the super admin
            fire
              .database()
              .ref("groupAccounts")
              .child(superadminUID)
              .child("members")
              .once("value")
              .then((snapshot) => {
                if (snapshot.exists()) {
                  snapshot.forEach((member) => {
                    fire
                      .database()
                      .ref("groupAccounts")
                      .child(superadminUID)
                      .child("members")
                      .child(member.key)
                      .once("value")
                      .then((memberDetail) => {
                        if (memberDetail.exists()) {
                          let member = memberDetail.val();
                          if (member.memberEmail === auth.currentUser.email) {
                            if (member.isAdmin === true) {
                              if (multiApprove) {
                                // add into activityLogs of the user's activity
                                fire
                                  .database()
                                  .ref("activityLogs")
                                  .child(auth.currentUser.uid) // get uid from auth person object
                                  .child(activityKey)
                                  .set({
                                    isRead: false,
                                    activity: 1,
                                    key: activityKey,
                                    Type: 1,
                                    description:
                                      "Granted access for multi approval",
                                    email: auth.currentUser.email,
                                    time: Math.floor(new Date()),
                                    userUID: auth.currentUser.uid,
                                    device: getDeviceDetails(),
                                  });
                              }

                              // selectedRecipients.forEach(async Recipient => {
                              //   // call cloud function getUserByEmail to get uid of recipient
                              //   let RecipientUID = await getUserId(Recipient.userEmail);
                              //   let curUserName = auth.currentUser.displayName;

                              //   if(sharingMode){
                              //     let message = '';

                              //     // check if one time access
                              //     if (OTAMode) {
                              //       //  check if timed
                              //       timedMode
                              //       ? message = ' has given you a Timed One-Time online lock access to '
                              //       : message = ' has given you One-Time online lock access to ';

                              //     } else {
                              //       timedMode
                              //       ? message = ' has given you a Timed online lock access to '
                              //       : message = ' has given you online lock access to ';
                              //     };

                              //     fire
                              //       .database()
                              //       .ref("individualNotifications")
                              //       .child(RecipientUID)
                              //       .child(notificationsKey)
                              //       .set({
                              //           isRead: false,
                              //           snapKey: notificationsKey,
                              //           notificationType: 1,
                              //           description: curUserName + message + selectedLock,
                              //           senderEmail: auth.currentUser.email,
                              //           timeStamp: Math.floor(new Date()),
                              //           senderUID: auth.currentUser.uid,
                              //           device: getDeviceDetails()
                              //       });
                              //   } else {
                              //     let message = '';

                              //     // check if one time access
                              //     if (OTAMode) {
                              //       //  check if timed
                              //       timedMode
                              //       ? message = ' has given you a Timed One-Time offline lock access to '
                              //       : message = ' has given you One-Time offline lock access to ';

                              //     } else {
                              //       timedMode
                              //       ? message = ' has given you a Timed offline lock access to '
                              //       : message = ' has given you offline lock access to ';
                              //     };

                              //     fire
                              //       .database()
                              //       .ref("individualNotifications")
                              //       .child(RecipientUID)
                              //       .child(notificationsKey)
                              //       .set({
                              //           isRead: false,
                              //           snapKey: notificationsKey,
                              //           notificationType: 1,
                              //           description: curUserName + message + selectedLock,
                              //           senderEmail: auth.currentUser.email,
                              //           timeStamp: Math.floor(new Date()),
                              //           senderUID: auth.currentUser.uid,
                              //           device: getDeviceDetails()
                              //       });
                              //   }
                              // });
                            }
                          }
                        }
                      });
                  });
                }
              });
          }
        });
      }
    });
};

const grantUserAccess = async (
  selectedRecipients,
  selectedGroups,
  selectedLockgroup,
  AlllockGroupArray,
  selectedLock,
  selectedDays,
  startTime,
  endTime,
  retractMode,
  OTAMode,
  recurringMode,
  recurringDailyAccess,
  selectedAdmins,
  showAdminLists,
  superAdminID,
  sharePermissionType,
  timedAccess,
  currentLanguage,
  callback
) => {
  // console.log("grantUserAccess");
  // customLog(showAdminLists);
  let userWithoutApp = [];
  // console.log(superAdminID);
  // console.log(selectedLockgroup);
  if (selectedLock != null && selectedLockgroup == null) {
    await saveActivityLogs(
      selectedRecipients,
      selectedLock.ip45SerialNumber,
      retractMode, //? Sharing mode switch
      showAdminLists, //? multi approve switch
      OTAMode, //? one time access switch
      timedAccess //? timed access switch
    );
  } else if (selectedLock == null && selectedLockgroup != null) {
    // console.log(selectedLockgroup);
    // console.log(AlllockGroupArray);
    AlllockGroupArray.forEach((selectedLock) => {
      const matchedLock = AlllockGroupArray.find(
        (lock) => lock.name === selectedLockgroup
      );
      if (matchedLock) {
        // console.log("Matched Lock:", matchedLock);
        for (const lockId in matchedLock.locks) {
          const lockCode = matchedLock.locks[lockId];
          saveActivityLogs(
            selectedRecipients,
            lockCode,
            retractMode, //? Sharing mode switch
            showAdminLists, //? multi approve switch
            OTAMode, //? one time access switch
            timedAccess //? timed access switch
          );
        }
      } else {
        // console.log("No match found for", selectedLock.name);
      }
    });
  }
  if (selectedGroups.length < 1) {
    for (let i = 0; i < selectedRecipients.length; i++) {
      const emailOfRecipient = selectedRecipients[i].userEmail;

      customLog("--admin---");
      customLog(selectedAdmins);

      customLog("--recipient---");
      customLog(selectedRecipients);

      customLog(selectedLock);
      await registeredUsersOnPlatformDB
        .orderByValue()
        .equalTo(emailOfRecipient)
        .once("value")
        .then(async (snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach(async (eachSnapshot) => {
              const shareToUid = eachSnapshot.key;
              const shareToEmail = eachSnapshot.val();

              const shareAccessToken = fire
                .database()
                .ref()
                .push().key;

              const key = retractableRegistryDB.push().key;

              const isGroup = false;

              customLog(shareToEmail);
              customLog(shareToUid);

              if (retractMode) {
                //! online mode, Push to registry

                //Update retractable registry
                await updateRetractableRegistry(
                  selectedLock,
                  selectedLockgroup,
                  selectedDays,
                  startTime,
                  endTime,
                  shareToUid,
                  shareToEmail,
                  shareAccessToken,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  showAdminLists,
                  key,
                  isGroup,
                  sharePermissionType,
                  retractMode
                  // false,
                  // selectedAdmins,
                );

                await updateRetractableMultiSharing(key, selectedAdmins);

                //update userlock
                await updateUserLocks(
                  selectedLock,
                  selectedLockgroup,
                  selectedDays,
                  startTime,
                  endTime,
                  superAdminID,
                  shareToUid,
                  shareToEmail,
                  shareAccessToken,
                  sharePermissionType,
                  retractMode,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  selectedAdmins,
                  showAdminLists,
                  key,
                  false
                );

                //update share history
                await updateShareHistory(
                  selectedLock,
                  selectedLockgroup,
                  shareToEmail,
                  startTime,
                  endTime,
                  retractMode
                );

                if (selectedLockgroup !== null) {
                  const mainKey = key;
                  fire
                    .database()
                    .ref("lockGroupManagement")
                    .child(superAdminID)
                    .child(auth.currentUser.uid)
                    .once("value")
                    .then(async (snapshot) => {
                      const snapshotData = snapshot.val();
                      if (snapshotData) {
                        Object.keys(snapshotData).forEach((key) => {
                          const childData = snapshotData[key];
                          if (childData.name === selectedLockgroup) {
                            if (childData.locks) {
                              Object.keys(childData.locks).forEach(
                                (lockKey) => {
                                  // updateRetractableRegistry(
                                  //   childData.locks[lockKey],
                                  //   null,
                                  //   selectedDays,
                                  //   startTime,
                                  //   endTime,
                                  //   shareToUid,
                                  //   shareToEmail,
                                  //   shareAccessToken,
                                  //   OTAMode,
                                  //   recurringMode,
                                  //   recurringDailyAccess,
                                  //   showAdminLists,
                                  //   mainKey,
                                  //   isGroup,
                                  //   sharePermissionType,
                                  //   true,
                                  //   selectedAdmins,
                                  // );

                                  updateUserLocks(
                                    childData.locks[lockKey],
                                    null,
                                    selectedDays,
                                    startTime,
                                    endTime,
                                    superAdminID,
                                    shareToUid,
                                    shareToEmail,
                                    shareAccessToken,
                                    sharePermissionType,
                                    retractMode,
                                    OTAMode,
                                    recurringMode,
                                    recurringDailyAccess,
                                    selectedAdmins,
                                    showAdminLists,
                                    mainKey,
                                    true
                                  );
                                }
                              );
                            }
                          }
                        });
                      }
                    });
                }
              } else {
                //! offline mode, push to userlocks and sharehistory

                //Update retractable registry
                await updateRetractableRegistry(
                  selectedLock,
                  selectedLockgroup,
                  selectedDays,
                  startTime,
                  endTime,
                  shareToUid,
                  shareToEmail,
                  shareAccessToken,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  showAdminLists,
                  key,
                  isGroup,
                  sharePermissionType,
                  retractMode
                  // false,
                  // selectedAdmins,
                );

                //update user lock
                await updateUserLocks(
                  selectedLock,
                  selectedLockgroup,
                  selectedDays,
                  startTime,
                  endTime,
                  superAdminID,
                  shareToUid,
                  shareToEmail,
                  shareAccessToken,
                  sharePermissionType,
                  retractMode,
                  OTAMode,
                  recurringMode,
                  recurringDailyAccess,
                  selectedAdmins,
                  showAdminLists,
                  key,
                  false
                );

                //update sharehistory
                await updateShareHistory(
                  selectedLock,
                  selectedLockgroup,
                  shareToEmail,
                  startTime,
                  endTime,
                  retractMode
                );

                if (selectedLockgroup !== null) {
                  const mainKey = key;
                  fire
                    .database()
                    .ref("lockGroupManagement")
                    .child(superAdminID)
                    .child(auth.currentUser.uid)
                    .once("value")
                    .then(async (snapshot) => {
                      const snapshotData = snapshot.val();
                      if (snapshotData) {
                        Object.keys(snapshotData).forEach((key) => {
                          const childData = snapshotData[key];
                          if (childData.name === selectedLockgroup) {
                            if (childData.locks) {
                              Object.keys(childData.locks).forEach(
                                (lockKey) => {
                                  // updateRetractableRegistry(
                                  //   childData.locks[lockKey],
                                  //   null,
                                  //   selectedDays,
                                  //   startTime,
                                  //   endTime,
                                  //   shareToUid,
                                  //   shareToEmail,
                                  //   shareAccessToken,
                                  //   OTAMode,
                                  //   recurringMode,
                                  //   recurringDailyAccess,
                                  //   showAdminLists,
                                  //   mainKey,
                                  //   isGroup,
                                  //   sharePermissionType,
                                  //   true,
                                  //   selectedAdmins,
                                  // );

                                  updateUserLocks(
                                    childData.locks[lockKey],
                                    null,
                                    selectedDays,
                                    startTime,
                                    endTime,
                                    superAdminID,
                                    shareToUid,
                                    shareToEmail,
                                    shareAccessToken,
                                    sharePermissionType,
                                    retractMode,
                                    OTAMode,
                                    recurringMode,
                                    recurringDailyAccess,
                                    selectedAdmins,
                                    showAdminLists,
                                    mainKey,
                                    true
                                  );
                                }
                              );
                            }
                          }
                        });
                      }
                    });
                }
              }

              //? if multi approve switch is true
              if (showAdminLists) {
                //? send email to each of the mutli approve admin
                if (selectedLockgroup == null && selectedLock != null) {
                  for (let i = 0; i < selectedAdmins.length; i++) {
                    const emailOfAdmin = selectedAdmins[i].adminEmail;
                    const multiDataToPost = {
                      email: emailOfAdmin,
                      ownerUid: auth.currentUser.uid,
                      shareTo: emailOfRecipient,
                      lockSerial: selectedLock.ip45SerialNumber,
                      language: currentLanguage,
                    };
                    fetch(
                      "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(multiDataToPost),
                      }
                    ).catch((err) => customLog(err));
                  }
                } else if (selectedLockgroup != null && selectedLock == null) {
                  for (let i = 0; i < selectedAdmins.length; i++) {
                    const emailOfAdmin = selectedAdmins[i].adminEmail;
                    const multiDataToPost = {
                      email: emailOfAdmin,
                      ownerUid: auth.currentUser.uid,
                      shareTo: emailOfRecipient,
                      lockSerial: selectedLockgroup.ip45SerialNumber,
                      language: currentLanguage,
                    };
                    fetch(
                      "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(multiDataToPost),
                      }
                    ).catch((err) => customLog(err));
                  }
                }
              }
              if (selectedLockgroup == null && selectedLock != null) {
                const dataToPost = {
                  email: emailOfRecipient,
                  ownerUid: auth.currentUser.uid,
                  lockSerial: selectedLock.ip45SerialNumber,
                  language: currentLanguage,
                };

                fetch(
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToPost),
                  }
                ).catch((err) => customLog(err));
              } else if (selectedLockgroup != null && selectedLock == null) {
                const dataToPost = {
                  email: emailOfRecipient,
                  ownerUid: auth.currentUser.uid,
                  lockSerial: selectedLockgroup.ip45SerialNumber,
                  language: currentLanguage,
                };

                fetch(
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToPost),
                  }
                ).catch((err) => customLog(err));
              }
            });
          } else {
            userWithoutApp.push(selectedRecipients[i]);
          }
        });
    }
  } else {
    // console.log("this is group grant access");
    for (let i = 0; i < selectedGroups.length; i++) {
      // console.log(selectedGroups[i].groupName);
      const shareToEmail = selectedGroups[i].groupName;
      const shareToUid = selectedGroups[i].groupID;

      const shareAccessToken = fire
        .database()
        .ref()
        .push().key;

      const key = retractableRegistryDB.push().key;

      const isGroup = true;
      // console.log(superAdminID);

      if (retractMode) {
        //! online mode

        //Update retractable registry
        await updateRetractableRegistry(
          selectedLock,
          selectedLockgroup,
          selectedDays,
          startTime,
          endTime,
          shareToUid,
          shareToEmail,
          shareAccessToken,
          OTAMode,
          recurringMode,
          recurringDailyAccess,
          showAdminLists,
          key,
          isGroup,
          sharePermissionType,
          retractMode
          // false,
          // selectedAdmins,
        );

        await updateRetractableMultiSharing(key, selectedAdmins);

        //update group management
        await updateGroupManagement(
          selectedLock,
          selectedDays,
          selectedLockgroup,
          startTime,
          endTime,
          superAdminID,
          shareToUid,
          shareToEmail,
          shareAccessToken,
          retractMode,
          recurringMode,
          recurringDailyAccess,
          OTAMode,
          showAdminLists,
          key,
          0
        );

        //update share history
        await updateShareHistory(
          selectedLock,
          selectedLockgroup,
          shareToEmail,
          startTime,
          endTime,
          retractMode
        );

        if (selectedLockgroup !== null) {
          const mainKey = key;
          let count = 0;
          fire
            .database()
            .ref("lockGroupManagement")
            .child(superAdminID)
            .child(auth.currentUser.uid)
            .once("value")
            .then(async (snapshot) => {
              const snapshotData = snapshot.val();
              if (snapshotData) {
                Object.keys(snapshotData).forEach((key) => {
                  const childData = snapshotData[key];
                  if (childData.name === selectedLockgroup) {
                    if (childData.locks) {
                      Object.keys(childData.locks).forEach((lockKey) => {
                        // updateRetractableRegistry(
                        //   childData.locks[lockKey],
                        //   null,
                        //   selectedDays,
                        //   startTime,
                        //   endTime,
                        //   shareToUid,
                        //   shareToEmail,
                        //   shareAccessToken,
                        //   OTAMode,
                        //   recurringMode,
                        //   recurringDailyAccess,
                        //   showAdminLists,
                        //   mainKey,
                        //   isGroup,
                        //   sharePermissionType,
                        //   true,
                        //   selectedAdmins,
                        // );

                        count = count + 1;

                        updateGroupManagement(
                          childData.locks[lockKey],
                          selectedDays,
                          null,
                          startTime,
                          endTime,
                          superAdminID,
                          shareToUid,
                          shareToEmail,
                          shareAccessToken,
                          retractMode,
                          recurringMode,
                          recurringDailyAccess,
                          OTAMode,
                          showAdminLists,
                          mainKey,
                          count
                        );
                      });
                    }
                  }
                });
              }
            });
        }
      } else {
        //! offline mode

        //Update retractable registry
        await updateRetractableRegistry(
          selectedLock,
          selectedLockgroup,
          selectedDays,
          startTime,
          endTime,
          shareToUid,
          shareToEmail,
          shareAccessToken,
          OTAMode,
          recurringMode,
          recurringDailyAccess,
          showAdminLists,
          key,
          isGroup,
          sharePermissionType,
          retractMode
          // false,
          // selectedAdmins,
        );

        //update group management
        await updateGroupManagement(
          selectedLock,
          selectedDays,
          selectedLockgroup,
          startTime,
          endTime,
          superAdminID,
          shareToUid,
          shareToEmail,
          shareAccessToken,
          retractMode,
          recurringMode,
          recurringDailyAccess,
          OTAMode,
          showAdminLists,
          key,
          0
        );

        //update sharehistory
        await updateShareHistory(
          selectedLock,
          selectedLockgroup,
          shareToEmail,
          startTime,
          endTime,
          retractMode
        );

        if (selectedLockgroup !== null) {
          const mainKey = key;
          let count = 0;
          fire
            .database()
            .ref("lockGroupManagement")
            .child(superAdminID)
            .child(auth.currentUser.uid)
            .once("value")
            .then(async (snapshot) => {
              const snapshotData = snapshot.val();
              if (snapshotData) {
                Object.keys(snapshotData).forEach((key) => {
                  const childData = snapshotData[key];
                  if (childData.name === selectedLockgroup) {
                    if (childData.locks) {
                      Object.keys(childData.locks).forEach((lockKey) => {
                        // updateRetractableRegistry(
                        //   childData.locks[lockKey],
                        //   null,
                        //   selectedDays,
                        //   startTime,
                        //   endTime,
                        //   shareToUid,
                        //   shareToEmail,
                        //   shareAccessToken,
                        //   OTAMode,
                        //   recurringMode,
                        //   recurringDailyAccess,
                        //   showAdminLists,
                        //   mainKey,
                        //   isGroup,
                        //   sharePermissionType,
                        //   true,
                        //   selectedAdmins,
                        // );

                        count = count + 1;

                        updateGroupManagement(
                          childData.locks[lockKey],
                          selectedDays,
                          null,
                          startTime,
                          endTime,
                          superAdminID,
                          shareToUid,
                          shareToEmail,
                          shareAccessToken,
                          retractMode,
                          recurringMode,
                          recurringDailyAccess,
                          OTAMode,
                          showAdminLists,
                          mainKey,
                          count
                        );
                      });
                    }
                  }
                });
              }
            });
        }
      }

      //? if multi approve switch is true
      if (showAdminLists) {
        //? send email to each of the mutli approve admin
        if (selectedLockgroup == null && selectedLock != null) {
          for (let i = 0; i < selectedAdmins.length; i++) {
            const emailOfAdmin = selectedAdmins[i].adminEmail;
            const multiDataToPost = {
              email: emailOfAdmin,
              ownerUid: auth.currentUser.uid,
              shareTo: shareToEmail,
              lockSerial: selectedLock.ip45SerialNumber,
            };
            fetch(
              "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(multiDataToPost),
              }
            ).catch((err) => customLog(err));
          }
        } else if (selectedLockgroup != null && selectedLock == null) {
          for (let i = 0; i < selectedAdmins.length; i++) {
            const emailOfAdmin = selectedAdmins[i].adminEmail;
            const multiDataToPost = {
              email: emailOfAdmin,
              ownerUid: auth.currentUser.uid,
              shareTo: shareToEmail,
              lockSerial: selectedLockgroup.ip45SerialNumber,
            };
            fetch(
              "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(multiDataToPost),
              }
            ).catch((err) => customLog(err));
          }
        }
      }
    }
    if (selectedLockgroup == null && selectedLock != null) {
      for (let i = 0; i < selectedRecipients.length; i++) {
        const emailOfRecipient = selectedRecipients[i].userEmail;

        await registeredUsersOnPlatformDB
          .orderByValue()
          .equalTo(emailOfRecipient)
          .once("value")
          .then(async (snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach(async (eachSnapshot) => {
                const dataToPost = {
                  email: emailOfRecipient,
                  ownerUid: auth.currentUser.uid,
                  lockSerial: selectedLock.ip45SerialNumber,
                  language: currentLanguage,
                };
                fetch(
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToPost),
                  }
                ).catch((err) => customLog(err));
              });
            } else {
              userWithoutApp.push(selectedRecipients[i]);
            }
          });
      }
    } else if (selectedLockgroup != null && selectedLock == null) {
      for (let i = 0; i < selectedRecipients.length; i++) {
        const emailOfRecipient = selectedRecipients[i].userEmail;
        // console.log(emailOfRecipient)

        await registeredUsersOnPlatformDB
          .orderByValue()
          .equalTo(emailOfRecipient)
          .once("value")
          .then(async (snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach(async (eachSnapshot) => {
                const dataToPost = {
                  email: emailOfRecipient,
                  ownerUid: auth.currentUser.uid,
                  lockSerial: selectedLockgroup.name,
                  language: currentLanguage,
                };
                fetch(
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToPost),
                  }
                ).catch((err) => customLog(err));
              });
            } else {
              userWithoutApp.push(selectedRecipients[i]);
            }
          });
      }
    }
  }

  const dataToCallback = {
    userWithoutApp: userWithoutApp,
    done: true,
  };
  // console.log(dataToCallback)
  callback(dataToCallback);
};

const grantUserLockGroupAccess = async (
  selectedRecipients,
  selectedGroups,
  selectedLockgroup,
  AlllockGroupArray,
  selectedLock,
  selectedDays,
  startTime,
  endTime,
  retractMode,
  OTAMode,
  recurringMode,
  recurringDailyAccess,
  selectedAdmins,
  showAdminLists,
  superAdminID,
  sharePermissionType,
  timedAccess,
  currentLanguage,
  callback
) => {
  let userWithoutApp = [];

  // ✅ Activity logs: do ONCE for lock group (don’t loop 1000 locks)
  try {
    if (selectedLock != null && selectedLockgroup == null) {
      await saveActivityLogs(
        selectedRecipients,
        selectedLock.ip45SerialNumber,
        retractMode,
        showAdminLists,
        OTAMode,
        timedAccess
      );
    } else if (selectedLock == null && selectedLockgroup != null) {
      // Just log the group name once (or use "group" serial)
      await saveActivityLogs(
        selectedRecipients,
        String(selectedLockgroup),
        retractMode,
        showAdminLists,
        OTAMode,
        timedAccess
      );
    }
  } catch (e) {
    // don’t block share on logging
    console.log("saveActivityLogs error:", e);
  }

  const shareToIndividual = async (emailOfRecipient) => {
    const snap = await registeredUsersOnPlatformDB
      .orderByValue()
      .equalTo(emailOfRecipient)
      .once("value");

    if (!snap.exists()) {
      userWithoutApp.push({ userEmail: emailOfRecipient });
      return;
    }

    const jobs = [];
    snap.forEach((eachSnapshot) => {
      jobs.push(
        (async () => {
          const shareToUid = eachSnapshot.key;
          const shareToEmail = eachSnapshot.val();

          const shareAccessToken = fire.database().ref().push().key;
          const key = retractableRegistryDB.push().key;

          // ✅ IMPORTANT: lock group share = ONE call only.
          await updateLockGroups(
            selectedLock, // null if lockgroup share
            selectedLockgroup, // string group name
            selectedDays,
            startTime,
            endTime,
            superAdminID,
            shareToUid,
            shareToEmail,
            shareAccessToken,
            sharePermissionType,
            retractMode,
            OTAMode,
            recurringMode,
            recurringDailyAccess,
            selectedAdmins,
            showAdminLists,
            key,
            false // recipientType INDIVIDUAL in updateLockGroups
          );

          await updateShareHistory(
            selectedLock,
            selectedLockgroup,
            shareToEmail,
            startTime,
            endTime,
            retractMode
          );

          // Multi-approve email requests (unchanged)
          if (showAdminLists) {
            if (selectedLockgroup == null && selectedLock != null) {
              for (let i = 0; i < selectedAdmins.length; i++) {
                const emailOfAdmin = selectedAdmins[i].adminEmail;
                const multiDataToPost = {
                  email: emailOfAdmin,
                  ownerUid: auth.currentUser.uid,
                  shareTo: emailOfRecipient,
                  lockSerial: selectedLock.ip45SerialNumber,
                  language: currentLanguage,
                };
                fetch(
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(multiDataToPost),
                  }
                ).catch((err) => customLog(err));
              }
            } else if (selectedLockgroup != null && selectedLock == null) {
              for (let i = 0; i < selectedAdmins.length; i++) {
                const emailOfAdmin = selectedAdmins[i].adminEmail;
                const multiDataToPost = {
                  email: emailOfAdmin,
                  ownerUid: auth.currentUser.uid,
                  shareTo: emailOfRecipient,
                  lockSerial: String(selectedLockgroup), // group name
                  language: currentLanguage,
                };
                fetch(
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(multiDataToPost),
                  }
                ).catch((err) => customLog(err));
              }
            }
          }

          // Grant access email to recipient (unchanged)
          const dataToPost =
            selectedLockgroup == null && selectedLock != null
              ? {
                  email: emailOfRecipient,
                  ownerUid: auth.currentUser.uid,
                  lockSerial: selectedLock.ip45SerialNumber,
                  language: currentLanguage,
                }
              : {
                  email: emailOfRecipient,
                  ownerUid: auth.currentUser.uid,
                  lockSerial: String(selectedLockgroup), // group name
                  language: currentLanguage,
                };

          fetch(
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(dataToPost),
            }
          ).catch((err) => customLog(err));
        })()
      );
    });

    await Promise.all(jobs);
  };

  const shareToGroup = async (group) => {
    const shareToEmail = group.groupName;
    const shareToUid = group.groupID;

    const shareAccessToken = fire.database().ref().push().key;
    const key = retractableRegistryDB.push().key;

    // ✅ IMPORTANT: lock group share = ONE call only.
    await updateLockGroups(
      selectedLock,
      selectedLockgroup,
      selectedDays,
      startTime,
      endTime,
      superAdminID,
      shareToUid,
      shareToEmail,
      shareAccessToken,
      sharePermissionType,
      retractMode,
      OTAMode,
      recurringMode,
      recurringDailyAccess,
      selectedAdmins,
      showAdminLists,
      key,
      true // recipientType GROUP in updateLockGroups
    );

    await updateShareHistory(
      selectedLock,
      selectedLockgroup,
      shareToEmail,
      startTime,
      endTime,
      retractMode
    );

    // Multi-approve emails (unchanged)
    if (showAdminLists) {
      if (selectedLockgroup == null && selectedLock != null) {
        for (let i = 0; i < selectedAdmins.length; i++) {
          const emailOfAdmin = selectedAdmins[i].adminEmail;
          const multiDataToPost = {
            email: emailOfAdmin,
            ownerUid: auth.currentUser.uid,
            shareTo: shareToEmail,
            lockSerial: selectedLock.ip45SerialNumber,
          };
          fetch(
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(multiDataToPost),
            }
          ).catch((err) => customLog(err));
        }
      } else if (selectedLockgroup != null && selectedLock == null) {
        for (let i = 0; i < selectedAdmins.length; i++) {
          const emailOfAdmin = selectedAdmins[i].adminEmail;
          const multiDataToPost = {
            email: emailOfAdmin,
            ownerUid: auth.currentUser.uid,
            shareTo: shareToEmail,
            lockSerial: String(selectedLockgroup),
          };
          fetch(
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/multiAccessRequestPermission",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(multiDataToPost),
            }
          ).catch((err) => customLog(err));
        }
      }
    }
  };

  try {
    if (!selectedGroups || selectedGroups.length < 1) {
      // ✅ share to individuals
      for (let i = 0; i < selectedRecipients.length; i++) {
        await shareToIndividual(selectedRecipients[i].userEmail);
      }
    } else {
      // ✅ share to groups
      for (let i = 0; i < selectedGroups.length; i++) {
        await shareToGroup(selectedGroups[i]);
      }
    }
  } catch (e) {
    console.log("grantUserLockGroupAccess error:", e);
  }

  callback({ userWithoutApp, done: true });
};


const updateUserLocks = async (
  lock,
  selectedLockgroup,
  selectedDays,
  startTime,
  endTime,
  superAdminID,
  shareToUid,
  shareToEmail,
  shareAccessToken,
  sharePermissionType,
  retractMode,
  OTAMode,
  recurrMode,
  recurringDailyAccess,
  selectedAdmins,
  showAdminLists,
  key,
  isLockGroupLock
) => {
  let isOfflineMode = false;
  let sharingMode = "";
  let lockData;
  let recurringDays = [];

  if (!retractMode) {
    isOfflineMode = true;
  }
  if (selectedLockgroup == null && lock != null) {
    // console.log(selectedLockgroup);
    // console.log(lock);
    if (recurrMode) {
      if (isLockGroupLock) {
        if (OTAMode && !showAdminLists) {
          sharingMode = "OTA-LOCKGRP";
        } else if (!OTAMode && showAdminLists) {
          sharingMode = "MULTI-LOCKGRP";
        } else if (OTAMode && showAdminLists) {
          sharingMode = "MULTI-OTA-LOCKGRP";
        } else if (recurringDailyAccess.TimedAccess) {
          sharingMode = "NORMAL-RECURR-TIMED-LOCKGRP";
        } else {
          sharingMode = "NORMAL-RECURR-LOCKGRP";
        }
      } else if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else if (recurringDailyAccess.TimedAccess) {
        sharingMode = "NORMAL-RECURR-TIMED";
      } else {
        sharingMode = "NORMAL-RECURR";
      }

      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      if (recurringDailyAccess.TimedAccess) {
        lockData =
          lock.sharePermissionType === 1
            ? {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              }
            : {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              };
      } else {
        lockData =
          lock.sharePermissionType === 1
            ? {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              }
            : {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              };
      }
    } else {
      if (isLockGroupLock) {
        if (OTAMode && !showAdminLists) {
          sharingMode = "OTA-LOCKGRP";
        } else if (!OTAMode && showAdminLists) {
          sharingMode = "MULTI-LOCKGRP";
        } else if (OTAMode && showAdminLists) {
          sharingMode = "MULTI-OTA-LOCKGRP";
        } else {
          sharingMode = "NORMAL-LOCKGRP";
        }
      } else if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else {
        sharingMode = "NORMAL";
      }

      lockData =
        lock.sharePermissionType === 1
          ? {
              Name: lock.Name,
              Password: lock.Password,
              Type: lock.Type,
              ip45SerialNumber: lock.ip45SerialNumber,
              isShared: true,
              shareStartTime: startTime,
              shareEndTime: endTime,
              sharedBy: auth.currentUser.email,
              id: lock.id,
              ownedBy: lock.ownedBy,
              shareAccessToken: shareAccessToken,
              shareAccessTokenByAdmin: lock.shareAccessToken,
              shareCount: 0,
              identifier: "",
              isOfflineLock: isOfflineMode,
              sharingMode: sharingMode,
              sharePermissionType: sharePermissionType,
              // isMultiShareLock: isMultiSharingModeOn
            }
          : {
              Name: lock.Name,
              Password: lock.Password,
              Type: lock.Type,
              ip45SerialNumber: lock.ip45SerialNumber,
              isShared: true,
              shareStartTime: startTime,
              shareEndTime: endTime,
              sharedBy: auth.currentUser.email,
              id: lock.id,
              ownedBy: lock.ownedBy,
              shareAccessToken: shareAccessToken,
              shareCount: 0,
              identifier: "",
              isOfflineLock: isOfflineMode,
              sharingMode: sharingMode,
              sharePermissionType: sharePermissionType,
              // isMultiShareLock: isMultiSharingModeOn
            };
    }
  } else if (selectedLockgroup != null && lock == null) {
    if (recurrMode) {
      if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else if (recurringDailyAccess.TimedAccess) {
        sharingMode = "NORMAL-RECURR-TIMED";
      } else {
        sharingMode = "NORMAL-RECURR";
      }

      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      if (recurringDailyAccess.TimedAccess) {
        lockData = {
          allowAccess: true,
          recipientName: shareToEmail,
          recipientType: "INDIVIDUAL",
          recipientUID: shareToUid,
          retractMode: retractMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          recurringDays: recurringDays,
          sharePermissionType: 0,
          sharingMode: sharingMode,
          selectedRecurringTime: {
            startTime: recurringDailyAccess.selectedTime.startTime,
            endTime: recurringDailyAccess.selectedTime.endTime,
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
        };
      } else {
        lockData = {
          allowAccess: true,
          recipientName: shareToEmail,
          recipientType: "INDIVIDUAL",
          retractMode: retractMode,
          recipientUID: shareToUid,
          shareStartTime: startTime,
          shareEndTime: endTime,
          recurringDays: recurringDays,
          sharePermissionType: 0,
          sharingMode: sharingMode,
          selectedRecurringTime: {
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
        };
      }
    } else {
      if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else {
        sharingMode = "NORMAL";
      }

      lockData = {
        allowAccess: true,
        recipientName: shareToEmail,
        recipientType: "INDIVIDUAL",
        recipientUID: shareToUid,
        shareStartTime: startTime,
        shareEndTime: endTime,
        sharePermissionType: 0,
        sharingMode: sharingMode,
      };
    }
  }
  if (selectedLockgroup == null && lock != null) {
    await userLocksDb.child(shareToUid).push(lockData);
  } else if (selectedLockgroup != null && lock == null) {
    fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then(async (snapshot) => {
        const snapshotData = snapshot.val();
        for (const childSnapshotKey in snapshotData) {
          const lockData2 = snapshotData[childSnapshotKey];
          const lockName = lockData2.name;
          // console.log(lockData2);
          // console.log(lockName);
          // console.log("data? " + (selectedLockgroup === lockName));

          if (selectedLockgroup === lockName) {
            const lockDetails = {
              key: childSnapshotKey,
              ...lockData2,
            };

            await groupManagementDB2
              .child(superAdminID)
              .child(auth.currentUser.uid)
              .child(lockDetails.key)
              .child("sharedInstances")
              .child(key)
              .update(lockData);
          }
        }
      });
  }
};

const updateLockGroups = async (
  lock,
  selectedLockgroup,
  selectedDays,
  startTime,
  endTime,
  superAdminID,
  shareToUid,
  shareToEmail,
  shareAccessToken,
  sharePermissionType,
  retractMode,
  OTAMode,
  recurrMode,
  recurringDailyAccess,
  selectedAdmins,
  showAdminLists,
  key,
  isLockGroupLock
) => {
  let isOfflineMode = false;
  let sharingMode = "";
  let lockData;
  let recurringDays = [];

  if (!retractMode) {
    isOfflineMode = true;
  }

  // console.log("updateLockGroups " + selectedLockgroup);
  // console.log("lock " + lock);
  if (selectedLockgroup == null && lock != null) {
    // console.log("11 " + selectedLockgroup + "11 " + lock);
    // console.log(lock);
    if (recurrMode) {
      if (isLockGroupLock) {
        if (OTAMode && !showAdminLists) {
          sharingMode = "OTA-LOCKGRP";
        } else if (!OTAMode && showAdminLists) {
          sharingMode = "MULTI-LOCKGRP";
        } else if (OTAMode && showAdminLists) {
          sharingMode = "MULTI-OTA-LOCKGRP";
        } else if (recurringDailyAccess.TimedAccess) {
          sharingMode = "NORMAL-RECURR-TIMED-LOCKGRP";
        } else {
          sharingMode = "NORMAL-RECURR-LOCKGRP";
        }
      } else if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else if (recurringDailyAccess.TimedAccess) {
        sharingMode = "NORMAL-RECURR-TIMED";
      } else {
        sharingMode = "NORMAL-RECURR";
      }

      // console.log("online sharingMode " + sharingMode);

      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      if (recurringDailyAccess.TimedAccess) {
        lockData =
          lock.sharePermissionType === 1
            ? {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              }
            : {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              };
      } else {
        lockData =
          lock.sharePermissionType === 1
            ? {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              }
            : {
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                id: lock.id,
                ownedBy: lock.ownedBy,
                shareAccessToken: shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                // isMultiShareLock: isMultiSharingModeOn
              };
      }
    } else {
      // console.log("11 not recurring " + selectedLockgroup + "11 " + lock);

      if (isLockGroupLock) {
        if (OTAMode && !showAdminLists) {
          sharingMode = "OTA-LOCKGRP";
        } else if (!OTAMode && showAdminLists) {
          sharingMode = "MULTI-LOCKGRP";
        } else if (OTAMode && showAdminLists) {
          sharingMode = "MULTI-OTA-LOCKGRP";
        } else {
          sharingMode = "NORMAL-LOCKGRP";
        }
      } else if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else {
        sharingMode = "NORMAL";
      }

      // console.log("online sharingMode " + sharingMode);

      lockData =
        lock.sharePermissionType === 1
          ? {
              Name: lock.Name,
              Password: lock.Password,
              Type: lock.Type,
              ip45SerialNumber: lock.ip45SerialNumber,
              isShared: true,
              shareStartTime: startTime,
              shareEndTime: endTime,
              sharedBy: auth.currentUser.email,
              id: lock.id,
              ownedBy: lock.ownedBy,
              shareAccessToken: shareAccessToken,
              shareAccessTokenByAdmin: lock.shareAccessToken,
              shareCount: 0,
              identifier: "",
              isOfflineLock: isOfflineMode,
              sharingMode: sharingMode,
              sharePermissionType: sharePermissionType,
              // isMultiShareLock: isMultiSharingModeOn
            }
          : {
              Name: lock.Name,
              Password: lock.Password,
              Type: lock.Type,
              ip45SerialNumber: lock.ip45SerialNumber,
              isShared: true,
              shareStartTime: startTime,
              shareEndTime: endTime,
              sharedBy: auth.currentUser.email,
              id: lock.id,
              ownedBy: lock.ownedBy,
              shareAccessToken: shareAccessToken,
              shareCount: 0,
              identifier: "",
              isOfflineLock: isOfflineMode,
              sharingMode: sharingMode,
              sharePermissionType: sharePermissionType,
              // isMultiShareLock: isMultiSharingModeOn
            };
    }
  } else if (selectedLockgroup != null && lock == null) {
    // console.log("12 " + selectedLockgroup + "12 " + lock);

    if (recurrMode) {
      if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else if (recurringDailyAccess.TimedAccess) {
        sharingMode = "NORMAL-RECURR-TIMED";
      } else {
        sharingMode = "NORMAL-RECURR";
      }

      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      // console.log("online sharingModwwe " + sharingMode);

      if (recurringDailyAccess.TimedAccess) {
        lockData = {
          allowAccess: true,
          recipientName: shareToEmail,
          recipientType: "INDIVIDUAL",
          recipientUID: shareToUid,
          retractMode: retractMode,
          isOfflineLock: isOfflineMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          recurringDays: recurringDays,
          sharePermissionType: 0,
          sharingMode: sharingMode,
          selectedRecurringTime: {
            startTime: recurringDailyAccess.selectedTime.startTime,
            endTime: recurringDailyAccess.selectedTime.endTime,
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
        };
      } else {
        lockData = {
          allowAccess: true,
          recipientName: shareToEmail,
          recipientType: "INDIVIDUAL",
          recipientUID: shareToUid,
          retractMode: retractMode,
          isOfflineLock: isOfflineMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          recurringDays: recurringDays,
          sharePermissionType: 0,
          sharingMode: sharingMode,
          selectedRecurringTime: {
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
        };
      }
    } else {
      if (OTAMode && !showAdminLists) {
        sharingMode = "OTA";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-OTA";
      } else if (isLockGroupLock) {
        sharingMode = "NORMAL-GRP";
      } else {
        sharingMode = "NORMAL";
      }

      // console.log("online sharingMsssde " + sharingMode);
      if (isLockGroupLock) {
        lockData = {
          allowAccess: true,
          recipientName: shareToEmail,
          recipientType: "GROUP",
          recipientUID: shareToUid,
          retractMode: retractMode,
          isOfflineLock: isOfflineMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          sharePermissionType: 0,
          sharingMode: sharingMode,
        };
      } else {
        lockData = {
          allowAccess: true,
          recipientName: shareToEmail,
          recipientType: "INDIVIDUAL",
          recipientUID: shareToUid,
          retractMode: retractMode,
          isOfflineLock: isOfflineMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          sharePermissionType: 0,
          sharingMode: sharingMode,
        };
      }
    }
  }

  //asdfasdf

  if (selectedLockgroup == null && lock != null) {
    // await userLocksDb.child(shareToUid).push(lockData);
  } else if (selectedLockgroup != null && lock == null) {
    fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then(async (snapshot) => {
        const snapshotData = snapshot.val();
        for (const childSnapshotKey in snapshotData) {
          const lockData2 = snapshotData[childSnapshotKey];
          const lockName = lockData2.name;
          // console.log(lockData2);
          // console.log(lockName);
          // console.log("data? " + (selectedLockgroup === lockName));

          if (selectedLockgroup === lockName) {
            const lockDetails = {
              key: childSnapshotKey,
              ...lockData2,
            };

            await groupManagementDB2
              .child(superAdminID)
              .child(auth.currentUser.uid)
              .child(lockDetails.key)
              .child("sharedInstances")
              .child(key)
              .update(lockData);
          }
        }
      });
  }
};

const updateRetractableRegistry = async (
  //change
  lock,
  selectedLockgroup,
  selectedDays,
  startDate,
  endDate,
  shareToUid,
  shareToEmail,
  shareAccessToken,
  OTAMode,
  recurringMode,
  recurringDailyAccess,
  showAdminLists,
  key,
  isGroup,
  sharePermissionType,
  retractMode
  // isLockGroupLock,
  // selectedAdmins,
) => {
  let sharingMode = "";
  let recurringDays = [];
  let registryData = {};
  let isOfflineLock = false;

  if (!retractMode) {
    isOfflineLock = true;
  }

  //
  if (OTAMode && !showAdminLists) {
    //no recurring currently
    // recurringMode ?
    //   isGroup ? (sharingMode = "RECURR-OTA-GRP") : (sharingMode = "RECURR-OTA")
    // :
    isGroup ? (sharingMode = "OTA-GRP") : (sharingMode = "OTA");
  } else if (!OTAMode && showAdminLists) {
    //no recurring currently
    // recurringMode ?
    //   isGroup ? (sharingMode = "RECURR-MULTI-GRP") : (sharingMode = "RECURR-MULTI")
    // :
    isGroup ? (sharingMode = "MULTI-GRP") : (sharingMode = "MULTI");
  } else if (OTAMode && showAdminLists) {
    //no recurring currently
    // recurringMode ?
    //   isGroup ? (sharingMode = "RECURR-MULTI-OTA-GRP") : (sharingMode = "RECURR-MULTI-OTA")
    // :
    isGroup ? (sharingMode = "MULTI-OTA-GRP") : (sharingMode = "MULTI-OTA");
  } else {
    recurringMode
      ? recurringDailyAccess.TimedAccess
        ? isGroup
          ? (sharingMode = "NORMAL-RECURR-TIMED-GRP")
          : (sharingMode = "NORMAL-RECURR-TIMED")
        : isGroup
        ? (sharingMode = "NORMAL-RECURR-GRP")
        : (sharingMode = "NORMAL-RECURR")
      : isGroup
      ? (sharingMode = "NORMAL-GRP")
      : (sharingMode = "NORMAL");
  }

  //add recurringDays: array of days [0] for all days, else [1,2,3,4,5,6,7] for the respective days
  if (selectedLockgroup == null && lock != null) {
    if (recurringMode && sharingMode.includes("NORMAL-RECURR")) {
      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      if (recurringDailyAccess.TimedAccess) {
        registryData =
          lock.sharePermissionType === 1
            ? {
                shareStartTime: startDate,
                shareEndTime: endDate,
                sharedOn: new Date() / 1000,
                sharedToUID: shareToUid,
                sharedToEmail: shareToEmail,
                senderUID: auth.currentUser.uid,
                sharedLockName: lock.Name,
                lockSerial: lock.ip45SerialNumber,
                lockId: lock.id,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                allowAccess: true,
                id: key,
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                hasAccessed: false,
                isOfflineLock: isOfflineLock,
              }
            : {
                shareStartTime: startDate,
                shareEndTime: endDate,
                sharedOn: new Date() / 1000,
                sharedToUID: shareToUid,
                sharedToEmail: shareToEmail,
                senderUID: auth.currentUser.uid,
                sharedLockName: lock.Name,
                lockSerial: lock.ip45SerialNumber,
                lockId: lock.id,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                allowAccess: true,
                id: key,
                shareAccessToken: shareAccessToken,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                hasAccessed: false,
                isOfflineLock: isOfflineLock,
              };
      } else {
        registryData =
          lock.sharePermissionType === 1
            ? {
                shareStartTime: startDate,
                shareEndTime: endDate,
                sharedOn: new Date() / 1000,
                sharedToUID: shareToUid,
                sharedToEmail: shareToEmail,
                senderUID: auth.currentUser.uid,
                sharedLockName: lock.Name,
                lockSerial: lock.ip45SerialNumber,
                lockId: lock.id,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                allowAccess: true,
                id: key,
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                hasAccessed: false,
                isOfflineLock: isOfflineLock,
              }
            : {
                shareStartTime: startDate,
                shareEndTime: endDate,
                sharedOn: new Date() / 1000,
                sharedToUID: shareToUid,
                sharedToEmail: shareToEmail,
                senderUID: auth.currentUser.uid,
                sharedLockName: lock.Name,
                lockSerial: lock.ip45SerialNumber,
                lockId: lock.id,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                allowAccess: true,
                id: key,
                shareAccessToken: shareAccessToken,
                sharingMode: sharingMode,
                sharePermissionType: sharePermissionType,
                hasAccessed: false,
                isOfflineLock: isOfflineLock,
              };
      }
    } else {
      registryData =
        lock.sharePermissionType === 1
          ? {
              shareStartTime: startDate,
              shareEndTime: endDate,
              sharedOn: new Date() / 1000,
              sharedToUID: shareToUid,
              sharedToEmail: shareToEmail,
              senderUID: auth.currentUser.uid,
              sharedLockName: lock.Name,
              lockSerial: lock.ip45SerialNumber,
              lockId: lock.id,
              allowAccess: true,
              id: key,
              shareAccessToken: shareAccessToken,
              shareAccessTokenByAdmin: lock.shareAccessToken,
              sharingMode: sharingMode,
              sharePermissionType: sharePermissionType,
              hasAccessed: false,
              isOfflineLock: isOfflineLock,
            }
          : {
              shareStartTime: startDate,
              shareEndTime: endDate,
              sharedOn: new Date() / 1000,
              sharedToUID: shareToUid,
              sharedToEmail: shareToEmail,
              senderUID: auth.currentUser.uid,
              sharedLockName: lock.Name,
              lockSerial: lock.ip45SerialNumber,
              lockId: lock.id,
              allowAccess: true,
              id: key,
              shareAccessToken: shareAccessToken,
              sharingMode: sharingMode,
              sharePermissionType: sharePermissionType,
              hasAccessed: false,
              isOfflineLock: isOfflineLock,
            };
    }
  } else if (selectedLockgroup != null && lock == null) {
    //change
    if (recurringMode && sharingMode.includes("NORMAL-RECURR")) {
      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      if (recurringDailyAccess.TimedAccess) {
        registryData = {
          shareStartTime: startDate,
          shareEndTime: endDate,
          sharedOn: new Date() / 1000,
          sharedToUID: shareToUid,
          sharedToEmail: shareToEmail,
          senderUID: auth.currentUser.uid,
          sharedLockName: selectedLockgroup,
          lockSerial: "group",
          // lockId: lock.id,
          recurringDays: recurringDays,
          selectedRecurringTime: {
            startTime: recurringDailyAccess.selectedTime.startTime,
            endTime: recurringDailyAccess.selectedTime.endTime,
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
          allowAccess: true,
          id: key,
          shareAccessToken: shareAccessToken,
          // shareAccessTokenByAdmin: lock.shareAccessToken,
          sharingMode: sharingMode,
          sharePermissionType: sharePermissionType,
          hasAccessed: false,
          isOfflineLock: isOfflineLock,
        };
      } else {
        registryData = {
          shareStartTime: startDate,
          shareEndTime: endDate,
          sharedOn: new Date() / 1000,
          sharedToUID: shareToUid,
          sharedToEmail: shareToEmail,
          senderUID: auth.currentUser.uid,
          sharedLockName: selectedLockgroup,
          lockSerial: "group",
          // lockId: lock.id,
          recurringDays: recurringDays,
          selectedRecurringTime: {
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
          allowAccess: true,
          id: key,
          shareAccessToken: shareAccessToken,
          // shareAccessTokenByAdmin: lock.shareAccessToken,
          sharingMode: sharingMode,
          sharePermissionType: sharePermissionType,
          hasAccessed: false,
          isOfflineLock: isOfflineLock,
        };
      }
    } else {
      registryData = {
        shareStartTime: startDate,
        shareEndTime: endDate,
        sharedOn: new Date() / 1000,
        sharedToUID: shareToUid,
        sharedToEmail: shareToEmail,
        senderUID: auth.currentUser.uid,
        sharedLockName: selectedLockgroup,
        lockSerial: "group",
        // lockId: lock.id,
        allowAccess: true,
        id: key,
        shareAccessToken: shareAccessToken,
        // shareAccessTokenByAdmin: lock.shareAccessToken,
        sharingMode: sharingMode,
        sharePermissionType: sharePermissionType,
        hasAccessed: false,
        isOfflineLock: isOfflineLock,
      };
    }
  }
  // if (isLockGroupLock) {
  //   const LGLKey = retractableRegistryDB.push().key;

  //   registryData.lockGroupShareId = key;
  //   registryData.id = LGLKey;

  //   await retractableRegistryDB
  //     .child(auth.currentUser.uid)
  //     .child(LGLKey)
  //     .update(registryData);

  //   updateRetractableMultiSharing(
  //     LGLKey,
  //     selectedAdmins
  //   );
  // } else {
  await retractableRegistryDB
    .child(auth.currentUser.uid)
    .child(key)
    .update(registryData);
  // }
};

const updateRetractableMultiSharing = async (key, selectedAdmins) => {
  const retractableRegistryMultiSharingDB = fire
    .database()
    .ref(
      "retractableSharingRegistry/" +
        auth.currentUser.uid +
        "/" +
        key +
        "/multiSharingAdmins/"
    );

  let multiSharingAdminsArray = [];

  for (let i = 0; i < selectedAdmins.length; i++) {
    multiSharingAdminsArray.push({
      adminEmail: selectedAdmins[i].adminEmail,
      adminUid: selectedAdmins[i].adminUid,
      hasAllowed: false,
    });

    await retractableRegistryMultiSharingDB
      .child(selectedAdmins[i].adminUid)
      .update({
        adminEmail: selectedAdmins[i].adminEmail,
        adminUid: selectedAdmins[i].adminUid,
        hasAllowed: false,
      });
  }
};

const updateShareHistory = async (
  lock,
  selectedLockgroup,
  shareToEmail,
  startTime,
  endTime,
  retractMode
) => {
  if (selectedLockgroup == null && lock != null) {
    const shareHistory = {
      sharedTo: shareToEmail,
      lockName: lock.Name,
      startDate: startTime,
      endDate: endTime,
      serialno: lock.ip45SerialNumber,
      lockmodel: lock.Type,
      sharingmode: retractMode,

      // sharedOn: new Date().toDateString()
      sharedOn: parseInt(new Date().getTime() / 1000, 0),
    };
    await shareHistoryDB.child(auth.currentUser.uid).push(shareHistory);
  } else if (selectedLockgroup != null && lock == null) {
    // console.log("no?");
    // console.log(selectedLockgroup);
    //change for grant access

    const shareHistory = {
      sharedTo: shareToEmail,
      lockName: selectedLockgroup,
      startDate: startTime,
      endDate: endTime,
      serialno: "group",
      lockmodel: "group",
      sharingmode: retractMode,

      // sharedOn: new Date().toDateString()
      sharedOn: parseInt(new Date().getTime() / 1000, 0),
    };
    await shareHistoryDB.child(auth.currentUser.uid).push(shareHistory);
  }
};

const updateGroupManagement = async (
  lock,
  selectedDays,
  selectedLockgroup,
  startTime,
  endTime,
  superAdminID,
  groupId,
  groupName,
  shareAccessToken,
  retractMode,
  recurringMode,
  recurringDailyAccess,
  OTAMode,
  showAdminLists,
  key,
  count
) => {
  // console.log(lock);
  // console.log(selectedLockgroup);
  // console.log(superAdminID);
  let isOfflineMode = false;
  let sharingMode = "";
  let recurringDays = [];

  if (!retractMode) {
    isOfflineMode = true;
  }

  if (recurringMode) {
    if (recurringDailyAccess.TimedAccess) {
      if (OTAMode && !showAdminLists) {
        sharingMode = "OTA-RECURR-GRP";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI-RECURR-TIMED-GRP";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-RECURR-TIMED-OTA-GRP";
      } else {
        sharingMode = "NORMAL-RECURR-TIMED-GRP";
      }
    } else {
      if (OTAMode && !showAdminLists) {
        sharingMode = "OTA-RECURR-GRP";
      } else if (!OTAMode && showAdminLists) {
        sharingMode = "MULTI-RECURR-GRP";
      } else if (OTAMode && showAdminLists) {
        sharingMode = "MULTI-RECURR-OTA-GRP";
      } else {
        sharingMode = "NORMAL-RECURR-GRP";
      }
    }
  } else {
    if (OTAMode && !showAdminLists) {
      sharingMode = "OTA-GRP";
    } else if (!OTAMode && showAdminLists) {
      sharingMode = "MULTI-GRP";
    } else if (OTAMode && showAdminLists) {
      sharingMode = "MULTI-OTA-GRP";
    } else {
      sharingMode = "NORMAL-GRP";
    }
  }

  // const key = groupManagementDB
  //   .child(superAdminId)
  //   .child(auth.currentUser.uid)
  //   .child(groupId)
  //   .child("groupLocks")
  //   .push().key;

  let groupLocks;
  if (selectedLockgroup == null && lock != null) {
    if (recurringMode) {
      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }

      if (recurringDailyAccess.TimedAccess) {
        groupLocks =
          lock.sharePermissionType === 1
            ? {
                allowAccess: true,
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                id: lock.id,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                sharedOn: new Date() / 1000,
                snapID: count === 0 ? key : key + count,
                ownedBy: lock.ownedBy,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: 0,
              }
            : {
                allowAccess: true,
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                id: lock.id,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                sharedOn: new Date() / 1000,
                snapID: count === 0 ? key : key + count,
                ownedBy: lock.ownedBy,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  startTime: recurringDailyAccess.selectedTime.startTime,
                  endTime: recurringDailyAccess.selectedTime.endTime,
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                shareAccessToken: shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: 0,
              };
      } else {
        groupLocks =
          lock.sharePermissionType === 1
            ? {
                allowAccess: true,
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                id: lock.id,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                sharedOn: new Date() / 1000,
                snapID: count === 0 ? key : key + count,
                ownedBy: lock.ownedBy,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                shareAccessToken: shareAccessToken,
                shareAccessTokenByAdmin: lock.shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: 0,
              }
            : {
                allowAccess: true,
                Name: lock.Name,
                Password: lock.Password,
                Type: lock.Type,
                ip45SerialNumber: lock.ip45SerialNumber,
                id: lock.id,
                isShared: true,
                shareStartTime: startTime,
                shareEndTime: endTime,
                sharedBy: auth.currentUser.email,
                sharedOn: new Date() / 1000,
                snapID: count === 0 ? key : key + count,
                ownedBy: lock.ownedBy,
                recurringDays: recurringDays,
                selectedRecurringTime: {
                  offset: (() => {
                    const currentDate = new Date();
                    const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
                    return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
                  })(),
                },
                shareAccessToken: shareAccessToken,
                shareCount: 0,
                identifier: "",
                isOfflineLock: isOfflineMode,
                sharingMode: sharingMode,
                sharePermissionType: 0,
              };
      }
    } else {
      groupLocks =
        lock.sharePermissionType === 1
          ? {
              allowAccess: true,
              Name: lock.Name,
              Password: lock.Password,
              Type: lock.Type,
              ip45SerialNumber: lock.ip45SerialNumber,
              id: lock.id,
              isShared: true,
              shareStartTime: startTime,
              shareEndTime: endTime,
              sharedBy: auth.currentUser.email,
              sharedOn: new Date() / 1000,
              snapID: count === 0 ? key : key + count,
              ownedBy: lock.ownedBy,
              shareAccessToken: shareAccessToken,
              shareAccessTokenByAdmin: lock.shareAccessToken,
              shareCount: 0,
              identifier: "",
              isOfflineLock: isOfflineMode,
              sharingMode: sharingMode,
              sharePermissionType: 0,
            }
          : {
              allowAccess: true,
              Name: lock.Name,
              Password: lock.Password,
              Type: lock.Type,
              ip45SerialNumber: lock.ip45SerialNumber,
              id: lock.id,
              isShared: true,
              shareStartTime: startTime,
              shareEndTime: endTime,
              sharedBy: auth.currentUser.email,
              sharedOn: new Date() / 1000,
              snapID: count === 0 ? key : key + count,
              ownedBy: lock.ownedBy,
              shareAccessToken: shareAccessToken,
              shareCount: 0,
              identifier: "",
              isOfflineLock: isOfflineMode,
              sharingMode: sharingMode,
              sharePermissionType: 0,
            };
    }
  } else if (selectedLockgroup != null && lock == null) {
    //change
    if (recurringMode) {
      if (selectedDays.sunday === true) {
        recurringDays.push(0);
      }
      if (selectedDays.monday === true) {
        recurringDays.push(1);
      }
      if (selectedDays.tuesday === true) {
        recurringDays.push(2);
      }
      if (selectedDays.wednesday === true) {
        recurringDays.push(3);
      }
      if (selectedDays.thursday === true) {
        recurringDays.push(4);
      }
      if (selectedDays.friday === true) {
        recurringDays.push(5);
      }
      if (selectedDays.saturday === true) {
        recurringDays.push(6);
      }
      if (recurringDailyAccess.TimedAccess) {
        groupLocks = {
          allowAccess: true,
          recipientName: groupName,
          recipientType: "GROUP",
          recipientUID: groupId,
          retractMode: retractMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          recurringDays: recurringDays,
          sharePermissionType: 0,
          sharingMode: sharingMode,
          selectedRecurringTime: {
            startTime: recurringDailyAccess.selectedTime.startTime,
            endTime: recurringDailyAccess.selectedTime.endTime,
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
        };
      } else {
        groupLocks = {
          allowAccess: true,
          recipientName: groupName,
          recipientType: "GROUP",
          recipientUID: groupId,
          retractMode: retractMode,
          shareStartTime: startTime,
          shareEndTime: endTime,
          recurringDays: recurringDays,
          sharePermissionType: 0,
          sharingMode: sharingMode,
          selectedRecurringTime: {
            offset: (() => {
              const currentDate = new Date();
              const timezoneOffsetMinutes = currentDate.getTimezoneOffset(); // Timezone offset in minutes
              return -timezoneOffsetMinutes * 60; // Convert to seconds and invert for UTC+ zones
            })(),
          },
        };
      }
    } else {
      groupLocks = {
        allowAccess: true,
        recipientName: groupName,
        recipientType: "GROUP",
        recipientUID: groupId,
        shareStartTime: startTime,
        shareEndTime: endTime,
        sharePermissionType: 0,
        sharingMode: sharingMode,
      };
    }
  }

  if (selectedLockgroup == null && lock != null) {
    await groupManagementDB
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .child(groupId)
      .child("groupLocks")
      .child(key)
      .set(groupLocks);
  } else if (selectedLockgroup != null && lock == null) {
    // console.log("hello here?")
    fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then(async (snapshot) => {
        // console.log(snapshot.val())
        const snapshotData = snapshot.val();
        for (const childSnapshotKey in snapshotData) {
          const lockData = snapshotData[childSnapshotKey];
          const lockName = lockData.name;
          // console.log(lockData);
          // console.log(lockName);
          // console.log("data?"+ selectedLockgroup === lockName);

          if (selectedLockgroup === lockName) {
            const lockDetails = {
              key: childSnapshotKey,
              ...lockData,
            };

            await groupManagementDB2
              .child(superAdminID)
              .child(auth.currentUser.uid)
              .child(lockDetails.key)
              .child("sharedInstances")
              .child(key)
              .update(groupLocks);
          }
        }
      });
  }
};

export { grantUserAccess };
export { grantUserLockGroupAccess };
